
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import IQueryShortDto = MdbsCore.IQueryShortDto;
import IQueryAnswerDto = MdbsCore.IQueryAnswerDto;
import {queryModule, studyDefinitionModule} from "@/store";
import IQueryAcceptDto = MdbsCore.IQueryAcceptDto;
import IQueryRevokeDto = MdbsCore.IQueryRevokeDto;
import IQuerySolveDto = MdbsCore.IQuerySolveDto;
import {deepCopy} from "@/auxillary";
import QueryTypeDefinitionDto = MdbsCore.QueryTypeDefinitionDto;
import IQueryEditDto = MdbsCore.IQueryEditDto;
import IQueryDeferDto = MdbsCore.IQueryDeferDto;
import QueriesCountIcon from "@/components/query/icons/QueriesCountIcon.vue";
import QueryAnswerMenuItem from "@/components/query/menu/QueryAnswerMenuItem.vue";
import QueryAnswerDialog from "@/components/query/dialogs/QueryAnswerDialog.vue";
import IQueryListResponse = MdbsCore.IQueryListResponse;
import QueryListResponse = MdbsCore.QueryListResponse;

@Component({
  name: 'PatientVisitQueriesMenu',
  components: {QueriesCountIcon, QueryAnswerMenuItem, QueryAnswerDialog},
})
export default class PatientVisitQueriesMenu extends Vue {
  @Prop({required: true})
  private referenceId: string;

  patientVisitQueries: IQueryListResponse | undefined = new QueryListResponse();
  showAnswerQuery = false;
  selectedQuery: IQueryShortDto | null = null;

  @Watch('patientVisitsQueries', {immediate: true})
  async patientVisitsQueriesChanged() {
    this.patientVisitQueries = queryModule.patientVisitQueriesById(this.referenceId);
  }

  get referenceType() {
    return "Visit";
  }

  get patientVisitsQueries() {
    return queryModule.patientVisitQueries;
  }

  get hasPatientVisitQueries() {
    const length = this.patientVisitQueries?.items?.length ?? 0;
    return length > 0;
  }

  get queries() {
    return this.patientVisitQueries?.items ?? [];
  }

  queryTypeDefinition(query: IQueryShortDto): QueryTypeDefinitionDto | undefined {
    if (!query)
      return undefined;
    return this.myVisibleQueryTypeDefinitions.find(qf => qf.definitionType == query.queryTypeDefinitionType);
  }

  handleAnswerQuery(query: IQueryShortDto) {
    this.selectedQuery = deepCopy(query);
    this.showAnswerQuery = true;
  }

  async handleEditQuery(queryEdit: IQueryEditDto) {
    await queryModule.editQuery(queryEdit);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleSaveAnswerQuery(queryAnswer: IQueryAnswerDto) {
    await queryModule.answerQuery(queryAnswer);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleRevokeAnswerQuery(queryRevoke: IQueryRevokeDto) {
    await queryModule.revokeQuery(queryRevoke);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleAcceptAnswerQuery(queryAccept: IQueryAcceptDto) {
    await queryModule.acceptQuery(queryAccept);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleSolveAnswerQuery(querySolve: IQuerySolveDto) {
    await queryModule.solveQuery(querySolve);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleDeferAnswerQuery(queryDefer: IQueryDeferDto) {
    await queryModule.deferQuery(queryDefer);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  get myVisibleQueryTypeDefinitions(): Array<QueryTypeDefinitionDto> {
    return studyDefinitionModule.myVisibleQueryTypeDefinitions;
  }
}
